import { Webhook } from "../common/model/objectTypes"
import { WEBHOOK_INFO, WEBHOOK_PRODUCT_INFO, WEBHOOK_SPECIFICATION } from "../utils/webhook/webhookDescriptions"
import { documentSignedBody, documentSignedTestConnectionBody, signatureStatusChangeBody } from "../utils/webhook/webhookObjects"
import { documentSignedJsonResponse, signatureStatusJsonResponse, testConnectionJsonResponse } from "../utils/webhook/webhookResponseJson"

const documentSigned :Webhook= {
    name: "Document Signed",
    productInfo: WEBHOOK_PRODUCT_INFO.SIG,
    webhookInfo: WEBHOOK_INFO.SIG,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SIG.documentSigned,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: documentSignedTestConnectionBody,
    responseBody: documentSignedBody,
    jsonResponse: documentSignedJsonResponse,
}

const signatureStatusChange :Webhook= {
    name: "Signature Status Changed",
    productInfo: WEBHOOK_PRODUCT_INFO.SIG,
    webhookInfo: WEBHOOK_INFO.SIGSTATUSCHANGE,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SIG.statusChange,
    testConnectionJson: testConnectionJsonResponse,
    testConnectionBody: documentSignedTestConnectionBody,
    responseBody: signatureStatusChangeBody,
    jsonResponse: signatureStatusJsonResponse,
}

export const getContent = (webhookName :string) => {    
    switch (webhookName) {
        case 'Document Signed':
            return documentSigned;
        case 'Signature Status Changed':
            return signatureStatusChange;
    }
}